// extracted by mini-css-extract-plugin
module.exports = {"container":"payment-connect_container__3pKGq","text":"payment-connect_text__3InpX"};